"use client";

import React, { useState, useEffect } from "react";
import styles from "./CeoMessage.module.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ModalVideo from "react-modal-video";

const CeoMessage = () => {
  const [open, setOpen] = useState(false);
  const [isOpenVideoModal, setOpenVideoModal] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Open modal once (iOS-safe)
  useEffect(() => {
    try {
      const hasSeen = localStorage.getItem("showCeoModal");
      if (!hasSeen) {
        setOpen(true);
      }
    } catch {
      // iOS private mode fallback
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    try {
      localStorage.setItem("showCeoModal", "true");
    } catch {}

    setOpen(false);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      className={styles.CeoDialog}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      {/* Close Button */}
      <Button
        className={styles.ModalClose}
        onTouchStart={(e) => {
          e.preventDefault();
          handleClose();
        }}
        onClick={handleClose}
      >
        <CloseRoundedIcon />
      </Button>

      <DialogContent>
        <DialogContentText>
          <div className={styles.CeoModalContainer}>
            <div className={styles.CeoPhotoContainer}>
              <div className={styles.CeoPhotoLeftCol}>
                <img
                  src="https://web-assets.myababil.com/website/ceo-profile-phone.png"
                  alt="CEO"
                />
              </div>

              <div className={styles.CeoPhotoRightCol}>
                <h1 className="CeoWelcomeText">Welcome from</h1>
                <h2>Ahasan U, CEO</h2>
              </div>
            </div>

            <div className={styles.CeoDescription}>
              👋🏻 Salaam & Welcome to Takbir! As the world’s first learning
              platform dedicated to learners and Mu’allimīn (teachers) of Islam,
              you're stepping into a truly rewarding experience, inshā’Allāh.
            </div>

            <div className={styles.CeoDescription}>
              Our Deen gives great value to seeking and sharing knowledge, and we
              hope Takbir becomes a meaningful part of your journey.
            </div>

            <ModalVideo
              channel="youtube"
              youtube={{ mute: 0, autoplay: 0 }}
              isOpen={isOpenVideoModal}
              videoId="L61p2uyiMSo"
              onClose={() => setOpenVideoModal(false)}
            />

            <div className="CeoSignature">Ahasan U</div>

            <div className={styles.CeoBottomText}>
              Founder & CEO of <strong>Takbir</strong>
            </div>

            <Button
              variant="contained"
              fullWidth
              className={styles.StartedButton}
              href="/search"
              onClick={() => {
                try {
                  localStorage.setItem("showCeoModal", "true");
                } catch {}
              }}
            >
              Explore Courses
            </Button>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CeoMessage;
